import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { ROUTES } from '@/config/routes';
import { useCreateOne } from '@/queries/admin';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Form, FormData } from './Form';

export const Create = () => {
  const navigate = useNavigate();
  const { mutateAsync: createTemplate } = useCreateOne('chat-templates');

  const onSubmit = async (data: FormData) => {
    try {
      await createTemplate({ data });
      toast.success('Шаблон чата успешно создан');
      navigate(ROUTES.ADMIN.CHATS_TEMPLATES);
    } catch (error) {
      console.error('Error creating chat template:', error);
      toast.error('Произошла ошибка при создании шаблона чата');
    }
  };

  return (
    <PageLayout
      breadcrumbs={[
        { label: 'Шаблоны чатов', href: ROUTES.ADMIN.CHATS_TEMPLATES },
        { label: 'Создание', href: '' },
      ]}
    >
      <Form onSubmit={onSubmit} />
    </PageLayout>
  );
};
